/* GoogleAnalytics.js */

import ReactGA from "react-ga4";
import { createBrowserHistory } from 'history';
import { getCookieConsentValue } from "react-cookie-consent";

const enabledGA = process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED;
const cookieName = process.env.REACT_APP_COOKIE_NAME;

function doGaTrack() {
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
}

export function Initialize() {
  if (enabledGA === 'true') {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
    const history = createBrowserHistory();
    history.listen(() => { Track(); });
  }
}

export function Track() {
  const cookieAccepted = getCookieConsentValue(cookieName);
  if (enabledGA === 'true' && cookieAccepted) { doGaTrack(); }
}
